export enum BaseModalSize {
  Small = 'sm',
  Large = 'lg',
  ExtraLarge = 'xl',
}
